/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { EncryptedData } from './EncryptedData';

export type SecuredInfoDetailItem = {
    securedInfoType: SecuredInfoDetailItem.securedInfoType;
    encryptedData: EncryptedData;
    /**
     * Time interval how long will be particular secured info displayed on FE screen.
     * The value is in seconds. If not provided, secure info remains open till customer won't close (navigate away from screen).
     *
     */
    displayInterval?: number;
};

export namespace SecuredInfoDetailItem {

    export enum securedInfoType {
        IPS_QR = 'IPS_QR',
    }


}

